import React from "react";
import Header from "../components/Header";
import PagesHero from "../components/PagesHero";
import AboutSection from "../components/AboutSection";
import TestimonialSection from "../components/TestimonialSection";
import FooterSection from "../components/FooterSection";
// import Note from "../components/Note";
import NumberCount from "../components/NumberCount";
import MsportModal from "../components/MsportModal";


export default function About() {
    const [showModal, setShowModal] = React.useState(true);
  
  return (
    <div>
      {showModal && <MsportModal setShowModal={setShowModal} />}
      <Header />
      <PagesHero page={"about"} />
      <AboutSection />
      {/* <div
        style={{
          maxWidth: 1125,
          margin: "5rem auto",
        }}
      >
        <Note />
      </div> */}

    

      <TestimonialSection />
      <NumberCount />
      <FooterSection />
    </div>
  );
}
